<nav class="navbar-light bg-light short-height my-nav flex-row justify-content-between">
  <span>
    <a data-cy="footer-cookies" class="gray-link" role="button" appCookiePopupTrigger>Cookies</a>
    <span class="vs"></span>

    <span data-cy="footer-terms" class="gray-link" role="button" appTermsPopupTrigger>
      {{ 'label.terms_and_conditions' | translate }}
    </span>
    <span class="vs"></span>

    <span data-cy="footer-privacy" class="gray-link" role="button" appPrivacyPopupTrigger>
      {{ 'label.privacy_policy' | translate }}
    </span>
  </span>

  <span>
    <span data-cy="footer-about" class="gray-link" role="button" appAboutPopupTrigger>
      {{ 'label.about' | translate }}
    </span>
    <span class="vs"></span>

    <a data-cy="footer-spotlab" class="gray-link" href="https://spotlab.org" target="_blank"> © SpotLab S.L. </a>
    <span class="vs"></span>
    <a data-cy="footer-support" class="gray-link" rel="nofollow" target="_blank" appSupportLink>
      {{'core.support' | translate}}</a>
  </span>
</nav>
